import React,{Component} from 'react';
import './VerifyRegistration.css';

import Footer from '../../components/Footer/Footer';
import Page from '@acri-tools/react-tools/components/Page/Page';
import routes from '../../utils/routes';
import { bannerImage, logo } from '../../theme/images';
import Message from '@acri-tools/react-tools/components/Message/Message';
import { axiosErrorHandler, push_history } from '@acri-tools/react-tools/utils/global';
import request from '@acri-tools/react-tools/utils/request';
import { API_URL } from '../../utils/config';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import classNames from 'classnames';

interface Props{
    match?: any,

    // redux
    login?:any
}


export default class VerifyRegistration extends Component<Props,{}>{
    state={
        loading: false,
        success: false,
        message: '',
        message_type: '',
    }


    componentDidMount(){
        this.verifyRegistration();
    }
    componentDidUpdate(prevProps:Props){
        if(prevProps.match?.params?.token !== this.props.match?.params?.token)
            this.verifyRegistration();
    }

    render(){
        return (
        <Page 
            footer={<Footer/>}
            id="verify-registration"
            title="Verify Registration"
            banner={{
                topBar:{
                    logo: logo,
                    routes
                },
                bannerImage: bannerImage
            }}
        >
            <div className="page-content">
                <div className="row-centered-column">
                    <div className="content-div"> 
                        {/* <div className="title-2">Ver Password</div> */}
                        <div className={`information-box ${this.state.message_type}`}>
                        {
                            this.state.loading ?
                                <div className="centered"><Spinner white/></div>
                            :
                                this.state.message

                        }
                        </div>
                        <div className="centered">
                            <div
                                className="custom-button login inline" 
                                onClick={()=>{ push_history('/login') }}
                            >
                                LOGIN
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Page>
        );
    }

    verifyRegistration = async () =>{
        this.setState({ loading: true })
        try{
            let res = await request(`${API_URL}/api/user-manager/v1/verifyRegistration/${this.props.match?.params?.token}`,{
                method:'get',
            })
            this.setState({
                message: `Your account has successfully been created !\nYou may now login to the platform.`,
                message_type: 'success'
            })

        }
        catch(e){
            axiosErrorHandler( e, { 
                functionName: 'verifyRegistration', 
            })
            if(e.response?.status === 409){
                return this.setState({
                    message: 'The account has already been activated',
                    message_type: 'warning'
                })
            }
            else 
                this.setState({
                    message_type: 'error',
                    message: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
                })
        }
        finally{
            this.setState({ loading: false })
        }
    }

};
